import axios from "axios";
import jwt_decode from "jwt-decode";
import { logOut } from "../../../common/utils";

export default class RicercaRapidaService{
    find(text,onSuccess,onError){
        let host = process.env.REACT_APP_API_URL;
        var objUser = JSON.parse(sessionStorage.getItem("user"));
        var decoded = jwt_decode(objUser.token);
        const configHeaders = {
        headers: {
            Authorization: "Bearer " + objUser.token,
            CF: decoded.CFA,
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        },
        };

        axios
        .get(host + `/api/v1/ricercarapida/${text}`,configHeaders)
        .then(
            (result)=>{
                if(result.status === 401){
                    logOut();
                }
                onSuccess(result.data);
            },
            (error)=>{
                if(error.response.status === 401){
                    logOut();
                }
                onError();
            }
        )
        .catch(error =>{
            onError();
        }
        )
    }
}